<div class="form-editor">
	<div class="row form-header">
		<div class="col header-title">{{ formdata.title }}</div>
		<div class="col-xs-auto px-0">
			<button mat-button [hidden]="editing" class="js-form-editor-edit header-button" (click)="editForm()">
				<mat-icon>edit</mat-icon>
			</button>
			<button mat-flat-button *ngIf="editing" class="js-form-editor-cancel header-button" (click)="closeForm()">
				<mat-icon>cancel</mat-icon>
			</button>
			<button
				mat-flat-button
				color="primary"
				*ngIf="editing"
				[disabled]="!formValidAndChanged()"
				class="js-form-editor-save save-button"
				(click)="saveForm()"
			>
				<span i18n="save button title">Save</span>
			</button>
		</div>
	</div>
	<div class="row-table">
		<div *ngIf="!editing; else editingForm">
			<div class="row display-row" *ngFor="let row of formdata.rows">
				<div class="col-12 title">{{ row.title }}</div>
				<div class="col-12 value">
					<span class="material-icons row-icon" [hidden]="!row.icon">{{ row.icon }}</span> {{ getDisplayLabel(row) }}
				</div>
			</div>
		</div>
		<ng-template #editingForm>
			<form [formGroup]="formInputs" class="container form-container">
				<mat-form-field appearance="standard" class="width-100 mx-auto form-field" *ngFor="let row of formdata.rows">
					<mat-label>{{ row.title }}</mat-label>
					<ng-container [ngSwitch]="row.type">
						<mat-select *ngSwitchCase="formEditorInputType.select" formControlName="{{ row.key }}" >
							<mat-option *ngFor="let option of row.options" [value]="option.value">{{ option.label }}</mat-option>
						</mat-select>
						<input matInput *ngSwitchDefault type="{{ row.type }}" formControlName="{{ row.key }}" name="{{ row.key }}" />
					</ng-container>
					<button
						mat-icon-button
						matSuffix
						(click)="resetControl(row.key)"
						i18n-title="reset form input button"
						title="Reset"
						[hidden]="controlSame(row.key)"
						type="button"
						tabindex="-1"
					>
						<mat-icon>replay</mat-icon>
					</button>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.get(row.key)"
						[type]="row.type"
					></mat-error>
					<div
						class="password-prompt"
						[ngClass]="{ 'text-success': showPasswordSuccess() }"
						*ngIf="row.key === 'password' && !showPasswordError()"
					>
						<span i18n>minimum 8, a mix of uppercase, lowercase and number characters</span>
					</div>
				</mat-form-field>
			</form>
		</ng-template>
	</div>
</div>
